"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Style", {
  enumerable: true,
  get: function get() {
    return _TouristsPicker.Style;
  }
});
Object.defineProperty(exports, "TouristsPickerOld", {
  enumerable: true,
  get: function get() {
    return _TouristsPickerOld.TouristsPickerOld;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TouristsPicker2["default"];
  }
});
var _TouristsPicker = require("./TouristsPicker.desktop");
var _TouristsPicker2 = _interopRequireDefault(require("./TouristsPicker"));
var _TouristsPickerOld = require("./TouristsPickerOld");